/* eslint-disable i18next/no-literal-string -- wire enum values, labelled through i18n at render */
export const SUPPORT_REQUEST_TYPES = ['bug', 'feature', 'question'] as const;
export type SupportRequestType = (typeof SUPPORT_REQUEST_TYPES)[number];

export const PLATFORM_AREAS = [
  'home',
  'sessions',
  'projects',
  'tools',
  'knowledge',
  'settings',
  'other',
] as const;
export type PlatformArea = (typeof PLATFORM_AREAS)[number];

export const FEATURE_FREQUENCIES = ['daily', 'weekly', 'monthly', 'rarely'] as const;
export type FeatureFrequency = (typeof FEATURE_FREQUENCIES)[number];

export const BLOCKER_ANSWERS = ['yes', 'no'] as const;
/* eslint-enable i18next/no-literal-string */

/** What gets submitted. Fields that do not apply to the chosen type are cleared. */
export interface SupportRequest {
  type: SupportRequestType;
  area: PlatformArea;
  /** Bug reports. */
  currentBehavior: string;
  expectedBehavior: string;
  isBlocker: boolean | null;
  /** Feature requests and questions. */
  description: string;
  frequency: FeatureFrequency | null;
  attachments: File[];
}
